import { useEffect, useState } from 'react'

import { create } from 'zustand'

export const useWaitInteractionStore = create<{
  isInteracted: boolean
  setIsInteracted: (value: boolean) => void
}>((set) => ({
  isInteracted: false,
  setIsInteracted: (value: boolean) => set({ isInteracted: value }),
}))

export const WaitInteractionListener = () => {
  const { setIsInteracted } = useWaitInteractionStore()

  useEffect(() => {
    // Function to handle user interaction
    if (window.hhg_isInteracted) {
      setIsInteracted(true)
      return
    }
    function userInteracted() {
      setIsInteracted(true)
      removeListeners()
    }

    // Add event listeners for different types of interactions
    document.addEventListener('click', userInteracted)
    document.addEventListener('keydown', userInteracted)
    document.addEventListener('mousemove', userInteracted)
    document.addEventListener('scroll', userInteracted)
    document.addEventListener('touchstart', userInteracted)

    // Optional: Remove event listeners after first interaction
    function removeListeners() {
      document.removeEventListener('click', userInteracted)
      document.removeEventListener('keydown', userInteracted)
      document.removeEventListener('mousemove', userInteracted)
      document.removeEventListener('scroll', userInteracted)
      document.removeEventListener('touchstart', userInteracted)
    }

    return () => {
      removeListeners()
    }
  }, [])

  return (
    <script
      async
      dangerouslySetInnerHTML={{
        __html: `
      ;(() => {
        function userInteracted() {
          window.hhg_isInteracted = true
          removeListeners()
        }
        // Add event listeners for different types of interactions
        document.addEventListener('click', userInteracted)
        document.addEventListener('keydown', userInteracted)
        document.addEventListener('mousemove', userInteracted)
        document.addEventListener('scroll', userInteracted)
        document.addEventListener('touchstart', userInteracted)

        // Optional: Remove event listeners after first interaction
        function removeListeners() {
          document.removeEventListener('click', userInteracted)
          document.removeEventListener('keydown', userInteracted)
          document.removeEventListener('mousemove', userInteracted)
          document.removeEventListener('scroll', userInteracted)
          document.removeEventListener('touchstart', userInteracted)
        }
      })()
    `,
      }}
    />
  )
}

// max wait in milliseconds
export const useWaitInteraction = (maxWait?: number) => {
  const { isInteracted } = useWaitInteractionStore()
  const [localWait, setLocalWait] = useState(false)

  useEffect(() => {
    if (maxWait) {
      const timeout = setTimeout(() => {
        setLocalWait(true)
      }, maxWait)

      return () => {
        clearTimeout(timeout)
      }
    }
  }, [maxWait])
  return localWait || isInteracted
}
